<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import url(./assets/css/rest.css);
  @import url(./assets/css/flex.css);
  body{
    margin:0;
  }
  .el-loading-mask{
    background-color:transparent;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue